// extracted by css-extract-rspack-plugin
export default {"list":"list-ArjN2e","day":"day-LArqGE"};